module.exports = __webpack_public_path__ + "img/w3_subset_dark.8cb0742a.png";